import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import CanvasEditorDialog from './CanvasEditorDialog';

type Props = {
	value: string;
	title: string;
	className?: string;
	onChange: (value: string) => void;
};

const CanvasImage = ({ value, title, onChange, className }: Props) => {
	const [openEditor, setOpenEditor] = useState(false);

	return (
		<div className="card overlay overflow-hidden spaces mt-8">
			<div className="card-body p-0">
				<div className="overlay-wrapper border border-secondary">
					<img
						src={value ?? toAbsoluteUrl('/media/images/image-placeholder.png')}
						alt={title}
						aria-label={title}
						className="w-100 h-auto rounded h-200px"
						style={{
							objectFit: 'contain',
						}}
					/>
				</div>
				<div className="overlay-layer bg-dark bg-opacity-25">
					<Button
						className="btn-fill spaces px-16 py-8"
						onClick={() => {
							setOpenEditor(true);
						}}
					>
						Chỉnh sửa
					</Button>
				</div>
			</div>

			{openEditor && (
				<CanvasEditorDialog
					open={openEditor}
					value={value}
					onClose={() => setOpenEditor(false)}
					onSave={(data) => {
						onChange(data);
						setOpenEditor(false);
					}}
					className={className}
				/>
			)}
		</div>
	);
};

export default CanvasImage;
